// extracted by mini-css-extract-plugin
module.exports = {"container":"ComingSoonPage_container__2bSzU","mainImg":"ComingSoonPage_mainImg__2w8CD","contentPanel":"ComingSoonPage_contentPanel__3e6Dl"};